import classNames from "classnames";
import classes from "./classes.module.scss";
import { useCallback, useState } from "react";
import Typography, { ITypo, ITypoColor } from "components/elements/Typography";

type ITabItem = {
	label: string;
	onClick: () => void;
};

type IProps = {
	items: (ITabItem | null)[];
};

export default function NavTabComponent(props: IProps) {
	const [selectItemId, setSelectItemId] = useState<number>(0);
	const onSelectItem = useCallback((itemId: number, item: ITabItem) => {
		setSelectItemId(itemId);
		item.onClick();
	}, []);

	if (props.items.length <= 0) return null;

	return (
		<div className={classes["root"]}>
			{props.items.map((item, index) => {
				if (!item) return null;
				const isActive = index === selectItemId;
				return (
					<Typography
						key={index}
						typo={isActive ? ITypo.P_MEDIUM_BOLD : ITypo.P_MEDIUM}
						color={isActive ? ITypoColor.BLACK : undefined}
						className={classNames(classes["link"], isActive && classes["active"])}
						onClick={() => onSelectItem(index, item)}>
						{item.label}
					</Typography>
				);
			})}
		</div>
	);
}
